export default "__VITE_ASSET__B28E3ikp__"